import React, {useContext} from 'react'
import {PageContext} from 'components/platform/hocs/PageContext'
import {FormattedMessage} from 'react-intl'
import {Button} from 'components/platform/buttons/Button'
import {useHistory} from "react-router-dom";
import {BackIcon, CancelIcon} from '../../../config/icons'

export const PageActionButtons = ({showDeleteButton = true, showSaveButton= true}) => {
  const {
    handleSave,
    handleDelete,
    handleClose,
    // handleSaveAndClose,
    buttonsConfig: buttons,
    remote,
  } = useContext(PageContext)
  const history = useHistory()
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        margin: '0 0 16px',
      }}
    >
      <div>
        {showDeleteButton === false || buttons.deleteButton === false || remote.loadingItem || !remote.item.id ? null : (
          <Button
            key="delete"
            onClick={handleDelete}
            color={'outline-danger'}
            loading={remote.deletingItem}
          >
            {/* Elimina */}
            <CancelIcon style={{ marginRight: 8 }} />
            {buttons.deleteLabel || <FormattedMessage id={'global.delete'} />}
          </Button>
        )}
      </div>
      <div>
        {(buttons.backButton !== false && history.length > 1) && (
          <Button
            tabIndex={-1}
            className={'mr-2 button-link'}
            color={'link'}
            key="back"
            onClick={handleClose}
            style={{ color: '#757575', textDecoration: 'underline' }}
          >
            <BackIcon style={{ marginRight: 8, fontSize: 16 }} />
            <FormattedMessage id={'global.back'} />
          </Button>
        )}
        {buttons.saveButton && (
          <Button
            key="submit2"
            onClick={handleSave}
            className={'mr-2'}
            color={buttons.saveButtonColor || "outline-primary"}
            loading={remote.savingItem}
          >
            <FormattedMessage id={buttons.saveButtonLabel || 'global.save_continue'} />
          </Button>
        )}
        {(buttons.saveCloseButton !== false && showSaveButton) && (
          <Button
            key="submit"
            onClick={handleSave/* handleSaveAndClose */}
            color="primary"
            aria-label="Save"
            loading={remote.savingItem}
          >
            {buttons.saveText || <FormattedMessage id={'global.save'} />}
          </Button>
        )}
      </div>
    </div>
  )
}
